import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, apiError } from "../lib/api";

function tokenFromUrl(): string {
  const hash = window.location.hash || "";
  const m = hash.match(/token=([^&]+)/);
  if (m) return decodeURIComponent(m[1]);
  const q = new URLSearchParams(window.location.search).get("token");
  return q || "";
}

export default function ResetPassword() {
  const [token] = useState<string>(tokenFromUrl());
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    if (!token) {
      setError("Lien de réinitialisation invalide ou incomplet.");
      return;
    }
    if (password.length < 8) {
      setError("Le mot de passe doit contenir au moins 8 caractères.");
      return;
    }
    if (password !== confirm) {
      setError("Les deux mots de passe ne correspondent pas.");
      return;
    }
    setBusy(true);
    try {
      await api.post("/auth/reset", { token, password });
      window.history.replaceState({}, "", "/reset");
      setDone(true);
    } catch (err) {
      setError(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-green p-4">
      <div className="nx-fade-up w-full max-w-sm">
        <div className="mb-6 flex flex-col items-center gap-3">
          <svg width="56" height="56" viewBox="0 0 100 100">
            <line x1="72" y1="22" x2="28" y2="78" stroke="#bcd2b2" strokeWidth="2.2" />
            <line x1="28" y1="22" x2="28" y2="78" stroke="#AADB4C" strokeWidth="6" strokeLinecap="round" />
            <line x1="72" y1="22" x2="72" y2="78" stroke="#AADB4C" strokeWidth="6" strokeLinecap="round" />
            <line x1="28" y1="22" x2="72" y2="78" stroke="#AADB4C" strokeWidth="6" strokeLinecap="round" />
            <circle cx="50" cy="50" r="9.7" fill="#AADB4C" />
            <circle cx="50" cy="50" r="3.3" fill="#00524A" />
          </svg>
          <h1 className="text-2xl font-extrabold tracking-wide text-white">NAXIUM ERP</h1>
        </div>

        {done ? (
          <div data-testid="reset-success" className="nx-card space-y-4 p-6 text-center">
            <p className="text-sm text-ink">Votre mot de passe a été réinitialisé. Vous pouvez maintenant vous connecter.</p>
            <Link data-testid="reset-login-link" to="/login" className="nx-btn-primary inline-flex w-full justify-center">
              Aller à la connexion
            </Link>
          </div>
        ) : (
          <form onSubmit={submit} className="nx-card space-y-4 p-6" data-testid="reset-form">
            <div>
              <h2 className="text-lg font-bold text-green">Nouveau mot de passe</h2>
              <p className="mt-1 text-sm text-muted">Choisissez un nouveau mot de passe pour votre compte Naxium ERP.</p>
            </div>
            <div>
              <label className="nx-label">Nouveau mot de passe (8 car. min.)</label>
              <input
                data-testid="reset-password-input"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="nx-input"
                placeholder="••••••••"
              />
            </div>
            <div>
              <label className="nx-label">Confirmez le mot de passe</label>
              <input
                data-testid="reset-confirm-input"
                type="password"
                required
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                className="nx-input"
                placeholder="••••••••"
              />
            </div>
            {error && (
              <p data-testid="reset-error" className="rounded-lg bg-red-50 px-3 py-2 text-sm text-danger">
                {error}
              </p>
            )}
            <button data-testid="reset-submit-btn" disabled={busy} className="nx-btn-primary w-full justify-center">
              {busy ? "Validation…" : "Réinitialiser mon mot de passe"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
